module.exports = __webpack_public_path__ + "static/media/heavy_pound41.1d29aa4c.jpg";